import { render, staticRenderFns } from "./GDUsageStatsTable.vue?vue&type=template&id=52d65668&scoped=true&"
import script from "./GDUsageStatsTable.vue?vue&type=script&lang=js&"
export * from "./GDUsageStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d65668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDataTable,VTooltip})
